/**
 * Whether a row from list-clients is a client at all. The endpoint returns the
 * raw table scan, and a counter or status write to a client that no longer
 * exists leaves a row with an id, a timestamp and a count and nothing else.
 * Such a row has no name to show and no stage to sit in, and sorting by name
 * throws on it.
 */
export function hasClientRecord(row: object): boolean {
  const { name, workflowStage } = row as { name?: unknown; workflowStage?: unknown }
  return typeof name === 'string' && typeof workflowStage === 'string'
}
